<template>
  <v-container-np id="services">
    <v-container-restricted
      class="text-center d-flex flex-column align-center"
      :class="Spacings.homePageSectionPadding"
    >
      <underlined-heading :text="$t('taHome.services')"></underlined-heading>

      <v-container-np :class="Spacings.homePageHeadingMargin">
        <v-row justify="center">
          <v-col
            v-for="(service, index) in services"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <SlideOnIntersectContainer
              :direction="index % 2 === 1 ? 'top' : 'bottom'"
              :full-height-container="true"
            >
              <v-card
                class="text-left rounded-xl h-100 d-flex flex-column text-center align-center ga-2 pa-8 bg-secondary-background"
                elevation="5"
              >
                <div
                  class="rounded-xl bg-white overflow-hidden"
                  style="width: 100%; aspect-ratio: 1; max-width: 100px"
                >
                  <Image
                    :cover="false"
                    :full-height="true"
                    :full-width="true"
                    :src="service.img"
                  ></Image>
                </div>
                <p class="text-h6">{{ service.name }}</p>
                <p class="text-subtitle-1">
                  {{ service.description }}
                </p>
              </v-card>
            </SlideOnIntersectContainer>
          </v-col>
        </v-row>
      </v-container-np>
    </v-container-restricted>
  </v-container-np>
</template>
<script setup lang="ts">
import { Spacings } from "~/core/constants/vuetify-class-constants/spacings";
import SlideOnIntersectContainer from "../common/animation/SlideOnIntersectContainer.vue";

const services: { name: string; img: string; description: string }[] = [
  {
    name: "AI Consulting",
    img: "https://img.freepik.com/free-vector/scientists-studying-neural-connections-programmers-writing-codes-machine-brain_74855-14157.jpg?t=st=1717598774~exp=1717602374~hmac=5687e81877d06dc2858fed9e74dc69e7cfe85deed7802adefd0fdbc94a945d05&w=400",
    description:
      "Our AI Consulting services provide expert guidance to help businesses leverage AI to optimize operations, improve decision-making, and drive innovation.",
  },
  {
    name: "Machine Learning Solutions",
    img: "https://img.freepik.com/free-vector/ai-powered-content-creation-isometric-concept-with-chatbot-laptop-screen-3d-vector-illustration_1284-82523.jpg?t=st=1717598879~exp=1717602479~hmac=21fda66dff51e9d682026f00c6a94b7c28d8068f1ff60a9c40df8f9cb24cca2d&w=400",
    description:
      "Our Machine Learning Solutions offer cutting-edge algorithms and models to solve complex business problems.",
  },
  {
    name: "Data Analytics",
    img: "https://img.freepik.com/free-vector/data-inform-illustration-concept_114360-864.jpg?t=st=1717598153~exp=1717601753~hmac=66a07883c8cd66674dbc2b5f4bfdb7e6de808f243104150dd051550deabfaed4&w=400",
    description:
      "Our Data Analytics services transform raw data into valuable insights to help businesses make data-driven decisions.",
  },
  {
    name: "Custom AI Solutions",
    img: "https://img.freepik.com/free-vector/cute-chatbot-greeting-people-isometric-icon-with-computer-various-objects-3d_1284-63055.jpg?t=st=1717598993~exp=1717602593~hmac=9e32ea39748677189cb1aacb4e001956a10082b77092297d5784027d94f8bb99&w=400",
    description:
      "Our Custom AI Solutions are expertly tailored to meet the specific and diverse needs of each unique and valued client.",
  },
];
</script>
